// CRM-grid option colours (§2.2 / erratum E-2). Each attribute VALUE maps to one of the fixed 8 PAIRED
// tokens (fg + -bg tint, both literal §2.2 hexes in tailwind.config — never /10-derived).

// slate is kept OUT of the hash pool so "no value" is always slate, never a hashed colour.
export const OPT_POOL = ['emerald', 'amber', 'rose', 'sky', 'violet', 'lime', 'fuchsia'] as const;
export type OptToken = typeof OPT_POOL[number] | 'slate';

// 🔴 STATIC class map — every one of the 16 classes written LITERALLY so Tailwind's JIT keeps them. A
// dynamic `bg-opt-${token}-bg` is invisible to the source scan and gets PURGED (the pills render untinted).
const OPT_CLASSES: Record<OptToken, { bg: string; fg: string }> = {
  emerald: { bg: 'bg-opt-emerald-bg', fg: 'text-opt-emerald' },
  amber:   { bg: 'bg-opt-amber-bg',   fg: 'text-opt-amber' },
  rose:    { bg: 'bg-opt-rose-bg',    fg: 'text-opt-rose' },
  sky:     { bg: 'bg-opt-sky-bg',     fg: 'text-opt-sky' },
  violet:  { bg: 'bg-opt-violet-bg',  fg: 'text-opt-violet' },
  slate:   { bg: 'bg-opt-slate-bg',   fg: 'text-opt-slate' },
  lime:    { bg: 'bg-opt-lime-bg',    fg: 'text-opt-lime' },
  fuchsia: { bg: 'bg-opt-fuchsia-bg', fg: 'text-opt-fuchsia' },
};

/** Tailwind classes for a token's {tint bg, fg text} pair (E-2 explicit paired, from the static map). */
export const optClasses = (t: OptToken): { bg: string; fg: string } => OPT_CLASSES[t];

// Semantic seed for the KNOWN P2 value sets (§2.2 conventional meanings), so colours read as designed
// rather than random. P3's per-tenant option registry replaces this seed; unknown values fall back to hash.
const SEMANTIC: Record<string, OptToken> = {
  'Cliente': 'emerald', 'Ganado': 'emerald',
  'Presupuesto enviado': 'amber', 'Templado': 'amber', 'En proceso': 'amber',
  'Sin presupuesto': 'slate',
  'Caliente': 'rose', 'Urgente': 'rose', 'Perdido': 'rose',
  'Frío': 'sky',
};

/** Deterministic value → token. Empty/null/unset → 'slate'; known values → their semantic token; else hash. */
export function optionToken(value: string | null | undefined): OptToken {
  if (!value || !value.trim()) return 'slate';
  const v = value.trim();
  if (SEMANTIC[v]) return SEMANTIC[v];
  let h = 0;
  for (let i = 0; i < v.length; i++) h = (h * 31 + v.charCodeAt(i)) >>> 0;
  return OPT_POOL[h % OPT_POOL.length];
}
